import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/vue-cookies'
import '@/plugins/vue-plugins'
import ErrorHandlingService from '@/services/ErrorHandlingService'
import ApiService from '@/services/ApiService'
import '@/registerServiceWorker'
import '@/assets/global.css'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

ErrorHandlingService.init(store)
ApiService.init(store, router)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
